import { useState, useEffect } from "react";
import { Input } from 'antd';

// Паспорт с маской ввода 00 00 000000
export const PassportInput = (props) => {

    // возвращает паспорт по маске 00 00 000000
    const formValueByMask = (inputedPassport) => {
        if (inputedPassport) {

            const clearedValue = inputedPassport.replaceAll(/[^\d_]/g, '');

            let finalValue = '';

            for (let i = 0; i < clearedValue.length; i++) {
                if (i === 2 || i === 4)
                    finalValue += ' ';

                finalValue += clearedValue[i];
            }

            return finalValue;
        }

        return '';
    }

    const { onChange, value, passportSerial, passportNumber, ...otherProps } = props;

    const [editingValue, setEditingValue] = useState(value);

    // диапазон выделения текста в поле ввода. См. также "isSetSelectionByVariables"
    const [fieldSelectionRange, setFieldSelectionRange] = useState({ start: 0, end: 0 });

    // true - установить диапазон выделения по "fieldSelectionRange",
    // иначе - стандартная установка по "<элементУправления>.selectionStart" и "<элементУправления>.selectionEnd"
    const [isSetSelectionByVariables, setIsSetSelectionByVariables] = useState(false);

    const internalFieldId = crypto.randomUUID();

    useEffect(() => setEditingValue(formValueByMask(value)), [value]);

    useEffect(() => {
        if (isSetSelectionByVariables)
            document.getElementById(internalFieldId).dispatchEvent(new Event('onSelect'));
    }, [fieldSelectionRange]);

    const setFieldSelectionValues = (start, end) => {
        setFieldSelectionRange({
            start: start,
            end: end
        })
    }

    // Индекс выделения на основе текущего индекса выделения с учетом примененной маски паспорта (см. описание элемента управления выше)
    const getSelectionPosition = (currentPosition) => {
        let newPosition = currentPosition;

        if (currentPosition === 2 || currentPosition === 3
            || currentPosition === 5 || currentPosition === 6)
            newPosition = currentPosition + 1;

        return newPosition;
    }

    const handleInternalFieldChange = (eventArgs) => {
        let finalValue = formValueByMask(eventArgs.currentTarget.value);
        setEditingValue(finalValue);

        // после изменения "eventArgs.currentTarget.value" индексы выделения изменятся.
        // То есть, если меняется символ в начале строки, то выделение перекинет в конец
        const selectionStart = getSelectionPosition(eventArgs.currentTarget.selectionStart);
        const selectionEnd = eventArgs.currentTarget.selectionStart === eventArgs.currentTarget.selectionEnd
            ? selectionStart
            : getSelectionPosition(eventArgs.currentTarget.selectionEnd);

        eventArgs.currentTarget.value = finalValue;

        onChange(eventArgs);

        setIsSetSelectionByVariables(true);

        setFieldSelectionValues(selectionStart, selectionEnd);
    }

    const handleInternalFieldSelectionChange = (eventArgs) => {
        if (isSetSelectionByVariables) {
            eventArgs.currentTarget.setSelectionRange(fieldSelectionRange.start, fieldSelectionRange.end);
            setIsSetSelectionByVariables(false);
        }
        else {
            setFieldSelectionRange(
                eventArgs.currentTarget.selectionStart,
                eventArgs.currentTarget.selectionEnd
            );

            eventArgs.currentTarget.setSelectionRange(eventArgs.currentTarget.selectionStart, eventArgs.currentTarget.selectionEnd);
        }
    }

    return (
        <Input
            {...otherProps}
            id={internalFieldId}
            onChange={handleInternalFieldChange}
            onSelect={handleInternalFieldSelectionChange}
            value={editingValue}
            placeholder='00 00 000000'
            count={
                {
                    max: 12,
                    exceedFormatter: (txt, { max }) => txt.slice(0, max)
                }
            }
        />
    );
}